import { createBrowserRouter } from "react-router-dom";
import "../assets/globals.scss";
import LayoutOne from "../components/layouts/LayoutOne";
import LayoutTwo from "components/layouts/LayoutTwo";
import LayoutThree from "components/layouts/LayoutThree";
import Home from "pages/home";
import Portfolio from "pages/portfolio";
import PortfolioDetail from "pages/portfolioDetail";
import NotFound from "pages/not-found";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <LayoutOne />,
        children: [
            {
                path: "",
                element: <Home />,
            },
        ],
    },
    {
        path: "/portfolio",
        element: <LayoutTwo />,
        children: [
            {
                path: "",
                element: <Portfolio />,
            }
        ],
    },
    {
        path: "/portfolio/:id",
        element: <LayoutThree />,
        children: [
            {
                path: "",
                element: <PortfolioDetail />,
            },
        ],
    },
    {
        path: "*",
        element: <NotFound />,
    },
]);
